<template>
	<div class="subcategories">
		<h4 class="text-uppercase" v-if="render_subcategories.length">Subcategorías</h4>
		<div class="custom-checkbox" v-for="sub in render_subcategories">
		    <input type="checkbox" class="sub-filters" :id="sub.id"/>
		    <label :for="sub.id" @click="toggleSubcategory($event, sub)">{{ sub.name }}</label>
		</div>
	</div>
</template>

<script>
import { router } from '../../routes/routes';
import { filterSub, getColors, resetColors, filterColor } from '../../store/actions';
var first = false;

export default {
	data () {
		return {
			subcategory: 0
		}
	},

	// ---- VUEX ----

	vuex: {
		getters: {
			categories: state => state.categories
		},
		actions: {
			filterSub,
			filterColor,
			getColors,
			resetColors
		}
	},

	// ---- RENDER ----

	computed: {
		render_subcategories () {
			if (this.categories.length) {
				let i = null;

				switch (this.$route.name) {
					case 'almacenamiento':
						i = 0;
						break;
					case 'sillas':
						i = 1;
						break;
					case 'mesas':
						i = 2;
						break;
					case 'salas':
						i = 3;
						break;
					case 'lamparas':
						i = 4;
						break;
					case 'accesorios':
						i = 5;
						break;
					case 'novedades':
						i = -1;
						break;
					case 'especiales':
						i = -1;
						break;
					default:
						i = 0;
						break;
				}

				if (i == -1) {
					return [];
				}

				this.subcategory = this.categories[i].childrens
				return this.categories[i].childrens;
			}

			return {};
		}
	},

	// ---- METHODS ----

	methods: {
		reset () {
			this.subcategory = null;
			$('input[type="radio"]').each((e, el) => {
				el.checked = false;
			});
		},

		toggleSubcategory (e, sub) {
			let $box = $(e.target).siblings('input[type="checkbox"]');
			let is_checked = $box.prop('checked');
			let cat = 0;

			if (is_checked) {
				router.go(`/${this.$route.name}?page=1`);

				switch (this.$route.name) {
					case 'almacenamiento':
						cat = 1;
						break;
					case 'sillas':
						cat = 6;
						break;
					case 'mesas':
						cat = 12;
						break;
					case 'salas':
						cat = 19;
						break;
					case 'lamparas':
						cat = 26;
						break;
					case 'accesorios':
						cat = 30;
						break;
				}

				this.resetColors();
				this.filterColor(0);
				this.getColors(cat);
				return;
			}

			$('.sub-filters').prop('checked', false);
			this.resetColors();
			this.filterColor(0);
			this.getColors(sub.id);
			router.go(`/${this.$route.name}?page=1&filter=${sub.id}`);
			// this.filterSub(sub.id);
		},

		setSubcategory () {
			let sub = this.$route.query.filter;
			let time = 0;

			if (!first) {
				time = 1000;
				first = true;
			} else {
				time = 0;
			}

			if (sub) {
				this.filterSub(sub);
				this.getColors(sub);
				// fuck i don't know how to resolve this,
				// without a timeout D:
				setTimeout(() => {
					$('.sub-filters').each((i, f) => {
						if (f.id == sub) {
							f.checked = true;
						}
					});
				}, time);
			}
		},

		setSubcategoryRouteChange () {
			router.afterEach(transition => {
				let sub = this.$route.query.filter;

				this.filterSub(sub);
				// this.setColors();

				// maybe unncesary code.
				// $('.sub-filters').prop('checked', false);
				
				// $('.sub-filters').each((i, f) => {
				// 	if (f.checked) {
				// 		$(f).prop('checked', false);
				// 	}
				// });
			});
		},

		setColors () {
			let cat = 0;
			this.resetColors();

			if (this.$route.query.filter) {
				return this.getColors(this.$route.query.filter);
			}

			switch (this.$route.name) {
				case 'almacenamiento':
					cat = 1;
					break;
				case 'sillas':
					cat = 6;
					break;
				case 'mesas':
					cat = 12;
					break;
				case 'salas':
					cat = 19;
					break;
				case 'lamparas':
					cat = 26;
					break;
				case 'accesorios':
					cat = 30;
					break;
			}
			
			if (cat) {
				this.getColors(cat);
			}
		}
	},

	// ---- READY ----

	ready () {
		// this.setColors();
		this.setSubcategory();
		this.setSubcategoryRouteChange();
	}
}
</script>


// WEBPACK FOOTER //
// Subcategories.vue?51dad533